module.exports = __webpack_public_path__ + "static/media/Tip.a20f3ee4.svg";